// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__AFKq6","inputDescription":"styles_inputDescription__N_7sz"};